import type { Block } from '@/types/blocks'
import type { ContentLang } from '../editorSlice'
import { buttonsForLang } from './blockButtons'
import type { DesignOverflowLevel } from './designOverflowMeasure'

/** Составной блок урока — с `id`, как его отдаёт сервер. */
export type DesignBlock = Extract<Block, { type: 'design' }>

/**
 * Ключ замера: язык, элементы и число ссылок этого языка — кнопки забирают высоту
 * холста, и без них в ключе кеш отдал бы устаревший ответ. Фон блока, подписи и
 * адреса кнопок, `NEXT_BUTTON` и кнопки другого языка высоту не меняют — их
 * правка заново мерить не заставляет.
 */
export const designOverflowCacheKey = (block: DesignBlock, lang: ContentLang): string =>
  `${lang}|${buttonsForLang(block.buttons, lang).length}|${JSON.stringify(block.elements)}`

// Замер дорогой (скрытый холст, ожидание шрифтов и картинок) — повторное
// наведение на «Опубликовать» с теми же элементами берёт готовый ответ.
const overflowCache = new Map<string, DesignOverflowLevel>()

export const readOverflowCache = (key: string): DesignOverflowLevel | undefined =>
  overflowCache.get(key)

export const writeOverflowCache = (key: string, level: DesignOverflowLevel): void => {
  overflowCache.set(key, level)
}
